import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { toast } from 'react-toastify';
import axiosInstance from '../../services/axiosInstance';

const Courts = () => {
  const navigate = useNavigate();
  const [courts, setCourts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get('/courts')
      .then(response => {
        setCourts(response.courts);
      })
      .catch(error => {
        console.error('Error al obtener las pistas:', error);
        toast.error('No se pudieron cargar las pistas.');
      })
      .finally(() => setLoading(false));
  }, []);

  const handleCourtSelect = courtId => {
    navigate(`/courts/${courtId}/schedule`);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom align="center">
        Selecciona una Pista
      </Typography>
      <Grid container spacing={4} pt={2}>
        {courts.map(court => (
          <Grid item xs={12} sm={6} md={3} key={court._id}>
            <Card>
              <CardMedia
                component="img"
                height="140"
                image={court.image || '/images/default-court.jpg'}
                alt={court.name}
                onError={e => (e.target.src = '/images/default-court.jpg')} // Si la imagen falla, mostrar una por defecto
              />
              <CardContent>
                <Typography variant="h6" pb={2} align="center">
                  {court.type.toUpperCase()} - {court.name}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleCourtSelect(court._id)}
                  fullWidth
                >
                  Seleccionar
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Courts;
